(function() {
  const HINT_ID = 'swipe-hint';
  const SHOW_MS = 5000; // 5秒
  const SESSION_KEY = 'swipeHintShownThisSession';
  const MOBILE_MAX = 1024; // モバイル/タブレット上限

  const isMobile = () => window.innerWidth <= MOBILE_MAX;
  const el = document.getElementById(HINT_ID);
  if (!el) return;

  let hideTimer = null;

  const show = (force = false) => {
    if (!isMobile()) return; // モバイル表示のみ
    // sessionStorageで「初回のみ」を制御。ただしforce時は再表示
    if (!force && sessionStorage.getItem(SESSION_KEY) === '1') return;

    // 可視化
    el.classList.add('is-visible');
    el.setAttribute('aria-hidden', 'false');

    // 5秒で自動非表示（再表示時はリセット）
    if (hideTimer) clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, SHOW_MS);

    // 初回表示フラグ
    if (!force) sessionStorage.setItem(SESSION_KEY, '1');
  };

  const hide = () => {
    el.classList.remove('is-visible');
    el.setAttribute('aria-hidden', 'true');
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
  };

  // ×ボタン、タップ/スワイプで即閉じる
  el.querySelector('.swipe-hint__close')?.addEventListener('click', hide, { passive: true });
  ['touchstart','mousedown','wheel','keydown'].forEach(evt =>
    window.addEventListener(evt, () => { if (el.classList.contains('is-visible')) hide(); }, { passive: true })
  );

  // 初回：ページロード後に一度だけ表示
  window.addEventListener('load', () => show(false));

  // 特定CTAクリック → 上部へスクロール & 再表示（強制）
  document.addEventListener('click', (e) => {
    const target = e.target.closest('[data-show-swipe-hint]');
    if (!target) return;

    e.preventDefault(); // 元リンクの遷移を止めたい場合のみ。遷移させたいなら削除
    // スクロール先：ページ最上部（必要なら.product__mediaなど要素に変更）
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    // スクロール完了をざっくり待ってから強制再表示
    // （scrollendはSafari未対応のためタイムアウトで代替）
    setTimeout(() => { show(true); }, 400);
  }, { passive: false });
})();
